import { useDashboardBootstrap } from './useDashboardBootstrap';

/**
 * useInsuranceEnabled — returns whether the current clinic has insurance enabled.
 *
 * Reads from the dashboard bootstrap so the decision is made by the backend
 * and shared across the staff UI. Defaults to false (fail-closed) while loading.
 */
export function useInsuranceEnabled(): boolean {
  const { data } = useDashboardBootstrap();
  return data?.insurance?.accepts_insurance ?? false;
}
